import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useLocale } from '../../contexts/LocaleContext';
import { useTheme } from '../../contexts/ThemeContext';
import { Button } from '../UI/button';

export default function ThemeToggle({ className }) {
  const { t } = useLocale();
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon-sm"
      className={className}
      onClick={toggleTheme}
      aria-label={t('landingThemeToggle')}
      title={isDark ? t('landingThemeLight') : t('landingThemeDark')}
    >
      {isDark ? <Sun className="size-4" aria-hidden /> : <Moon className="size-4" aria-hidden />}
    </Button>
  );
}
